import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button, Carousel, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const EventsSection: React.FC = () => {
  const [notifications, setNotifications] = useState<string[]>([]);
  const [eventSlides, setEventSlides] = useState<any[]>([]);
  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch notifications and event slides on component mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch notifications
        const notificationsRes = await fetch(`${API_URL}/api/notifications`);
        if (!notificationsRes.ok) throw new Error('Failed to fetch notifications');
        const notificationsData = await notificationsRes.json();
        setNotifications(notificationsData.map((item: any) => item.message));

        // Fetch event slides
        const eventSlidesRes = await fetch(`${API_URL}/api/event-slides`);
        if (!eventSlidesRes.ok) throw new Error('Failed to fetch event slides');
        const eventSlidesData = await eventSlidesRes.json();
        setEventSlides(eventSlidesData);
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };
    fetchData();
  }, []);

  return (
    <section className="events-section py-5">
      <Container>
        <Row>
          {/* Left Side: Upcoming Event Notification */}
          <Col md={6} className="mb-4">
            <Card className="notification-box">
              <Card.Header className="notification-title">
                <h3 className="mb-0">👉 Upcoming Event Notifications</h3>
              </Card.Header>
              <Card.Body className="notification-list">
                {notifications.length > 0 ? (
                  notifications.map((notification, index) => (
                    <Card.Text key={index} className="notification-item">
                      <i className="fas fa-bell me-2"></i> {notification}
                    </Card.Text>
                  ))
                ) : (
                  <Card.Text>No notifications available.</Card.Text>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* Right Side: Event Slider */}
          <Col md={6} className="mb-4">
            <div className="event-slider-box">
              <Carousel fade indicators={true} controls={true} interval={3000} pause="hover">
                {eventSlides.length > 0 ? (
                  eventSlides.map((slide, index) => (
                    <Carousel.Item key={index}>
                      <div className="event-slide">
                        <img
                          src={`${API_URL}${slide.imageUrl}`}
                          alt={slide.title}
                          className="event-image"
                        />
                        <div className="event-overlay">
                          <div className="event-content">
                            <h4 className="event-title">{slide.title}</h4>
                            <p className="event-desc">{slide.description}</p>
                            <Link to="/donate/">
                              <Button variant="danger" className="me-2">
                                Donate Now
                              </Button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))
                ) : (
                  <Carousel.Item>
                    <div className="event-slide">
                      <div className="event-overlay">
                        <div className="event-content">
                          <h4 className="event-title">No Events Available</h4>
                          <p className="event-desc">Check back later for upcoming events!</p>
                        </div>
                      </div>
                    </div>
                  </Carousel.Item>
                )}
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventsSection;
